module.exports = __webpack_public_path__ + "static/media/Elipay_logo.b49c44f5.svg";